import { Step, StepLabel, Stepper } from '../../base';
import { IStepperInfo } from '../../common';
import { CustomStepIcon, StepConnector } from './BasicStepper.styles';

interface Props {
    stepperInfo: IStepperInfo;
}
const BasicStepper = (props: Props) => {
    const { stepperInfo } = props;
    return (
        <Stepper orientation="vertical" connector={<StepConnector />}>
            {stepperInfo.steps.map((step, index) => (
                <Step
                    key={step.labelText}
                    // onMouseEnter={(e) => handlePopoverOpen(e, index)}
                    // onMouseLeave={handlePopoverClose}
                >
                    <StepLabel
                        StepIconComponent={() => (
                            <CustomStepIcon
                                isActive={index === stepperInfo.activeStepIndex}
                            >
                                <span>{step.labelText}</span>
                            </CustomStepIcon>
                        )}
                    />
                </Step>
            ))}
        </Stepper>
    );
};

export default BasicStepper;
